$(function() {
  // Show YouTube Frame
  var mobile = false;
  var ua = navigator.userAgent;
  if (
    ua.indexOf('iPhone') > 0 ||
    ua.indexOf('iPod') > 0 ||
    ua.indexOf('iPad') > 0 ||
    (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
  ) {
    mobile = true;
  }
  function onPlayerReady(event) {
    if (mobile) {
      event.target.mute();
    }
    event.target.playVideo();
  }
  $('.item_yt').append('<i></i>');
  $('.item_yt i, .item_yt_thumb').click(function() {
    var video_target = $(this).closest('.item_yt').find('.item_yt_thumb');
    var video_id = video_target.data('video');
    var player_id = video_target.next().attr('id');
    player = new YT.Player(player_id, {
      height: '405',
      width: '720',
      playerVars: {
        playsinline: 1
      },
      videoId: video_id,
      events: {
        onReady: onPlayerReady
      }
    });
    video_target.hide();
    $('.item_yt i').remove();
  });

  // Fixed Add Cart Button
  const fixedTarget = $('#AddToCart'),
        fixedStartArea = $('.product-description'),
        fixedFinishArea = $('.site-footer');
  var scrollStart = fixedStartArea.offset().top,
      scrollEnd = fixedFinishArea.offset().top,
      scrollAmount = 0;

  $(document).scroll(function(){
    scrollAmount = $(this).scrollTop();
    if (scrollStart <= scrollAmount) {
      fixedTarget.addClass('is_fixed');
    } else if (scrollStart >= scrollAmount) {
      fixedTarget.removeClass('is_fixed');
    }

    if (scrollEnd <= scrollAmount) {
      fixedTarget.fadeOut();
    } else {
      fixedTarget.fadeIn();
    }

    if($(window).scrollTop() < scrollAmount ){
      $('body').addClass('scrollUp');
      $('body').removeClass('scrollDown');
    } else {
      $('body').addClass('scrollDown');
      $('body').removeClass('scrollUp');
    }
  });

  // Add Class when iPhone User
  if ( navigator.userAgent.indexOf('iPhone') > 0 ) {
      $('body').addClass('iPhone');
  };
});
